"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

// Copied from ant.design table component
// https://github.com/react-component/table/blob/master/src/ColumnManager.js
var ColumnManager =
/*#__PURE__*/
function () {
  function ColumnManager(_columns) {
    var _this = this;

    (0, _classCallCheck2.default)(this, ColumnManager);
    (0, _defineProperty2.default)(this, "_cached", {});
    (0, _defineProperty2.default)(this, "hasFixed", function () {
      return _this._cache('hasFixed', function () {
        return _this.columns.some(function (column) {
          return !!column.fixed;
        });
      });
    });
    (0, _defineProperty2.default)(this, "hasFixedLeft", function () {
      return _this._cache('hasFixedLeft', function () {
        return _this.columns.some(function (column) {
          return column.fixed === 'left';
        });
      });
    });
    (0, _defineProperty2.default)(this, "hasFixedRight", function () {
      return _this._cache('hasFixedRight', function () {
        return _this.columns.some(function (column) {
          return column.fixed === 'right';
        });
      });
    });
    (0, _defineProperty2.default)(this, "leftColumns", function () {
      return _this._cache('leftColumns', function () {
        return _this.groupedColumns().filter(function (column) {
          return column.fixed === 'left';
        });
      });
    });
    (0, _defineProperty2.default)(this, "rightColumns", function () {
      return _this._cache('rightColumns', function () {
        return _this.groupedColumns().filter(function (column) {
          return column.fixed === 'right';
        });
      });
    });
    (0, _defineProperty2.default)(this, "groupedColumns", function () {
      return _this._cache('groupedColumns', function () {
        var _groupColumns = function _groupColumns(columns) {
          var currentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          var parentColumn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var rows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
          // track how many rows we got
          rows[currentRow] = rows[currentRow] || [];
          var grouped = [];

          var setRowSpan = function setRowSpan(column) {
            var rowSpan = rows.length - currentRow;

            if (column && !column.children && // parent columns are supposed to be one row
            rowSpan > 1 && (!column.rowSpan || column.rowSpan < rowSpan)) {
              column.rowSpan = rowSpan;
            }
          };

          columns.forEach(function (column, index) {
            var newColumn = (0, _objectSpread2.default)({}, column);
            rows[currentRow].push(newColumn);
            parentColumn.colSpan = parentColumn.colSpan || 0;

            if (newColumn.children && newColumn.children.length > 0) {
              newColumn.children = _groupColumns(newColumn.children, currentRow + 1, newColumn, rows);
              parentColumn.colSpan += newColumn.colSpan;
            } else {
              parentColumn.colSpan += 1;
            } // update rowspan to all same row columns


            for (var i = 0; i < rows[currentRow].length - 1; i += 1) {
              setRowSpan(rows[currentRow][i]);
            } // last column, update rowspan immediately


            if (index + 1 === columns.length) {
              setRowSpan(newColumn);
            }

            grouped.push(newColumn);
          });
          return grouped;
        };

        return _groupColumns(_this.columns);
      });
    });
    (0, _defineProperty2.default)(this, "leafColumns", function () {
      return _this._cache('leafColumns', function () {
        return _this._leafColumns(_this.groupedColumns());
      });
    });
    (0, _defineProperty2.default)(this, "leftLeafColumns", function () {
      return _this._cache('leftLeafColumns', function () {
        return _this._leafColumns(_this.leftColumns());
      });
    });
    (0, _defineProperty2.default)(this, "rightLeafColumns", function () {
      return _this._cache('rightLeafColumns', function () {
        return _this._leafColumns(_this.rightColumns());
      });
    });
    this.columns = _columns;
  }

  (0, _createClass2.default)(ColumnManager, [{
    key: "reset",
    value: function reset(columns) {
      this.columns = columns;
      this._cached = {};
    }
  }, {
    key: "_cache",
    value: function _cache(name, fn) {
      if (name in this._cached) {
        return this._cached[name];
      }

      this._cached[name] = fn();
      return this._cached[name];
    }
  }, {
    key: "_leafColumns",
    value: function _leafColumns(columns) {
      var _this2 = this;

      var leafColumns = [];
      columns.forEach(function (column) {
        if (!column.children) {
          leafColumns.push(column);
        } else {
          leafColumns.push.apply(leafColumns, (0, _toConsumableArray2.default)(_this2._leafColumns(column.children)));
        }
      });
      return leafColumns;
    }
  }]);
  return ColumnManager;
}();

exports.default = ColumnManager;